import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import Input from '../../../shared/form-elements/input';

lessRequire('modules/offers/components/filters/search-field.less');

let timeoutId;

const SearchField = props => {
	return (
		<Input
			className="form-element offers-search-form-element"
			{...props}
			placeholder={props.intl('Поиск по офферам')}
			onChange={e => {
				clearTimeout(timeoutId);
				props.input.onChange(e);
				timeoutId = setTimeout(() => {
					props.onSubmitForm();
					props.input.onFocus();
				}, 400);
			}}
		/>
	);
};

SearchField.propTypes = {
	intl: PropTypes.func,
	input: PropTypes.object
};
export default SearchField;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/filters/search-field.js